function createNumberFormat() {
  function formatCurrencyBR(value) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL"
    }).format(value)
  }

  function formatNumberBR(value) {
    return new Intl.NumberFormat("pt-BR", {
      currency: "BRL"
    }).format(value)
  }

  function formatForNumber(value) {
    return Number(value)
  }

  return {
    formatCurrencyBR,
    formatNumberBR,
    formatForNumber
  }
}

export default createNumberFormat
